import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { postAPI_Update_Property } from '../../../../../../../constants/APIs';
import { PropertyForm } from './PropertyForm';

export default function UpdatePropertyForm({ id, groupId }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [visible, setVisible] = useState(false);
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };
    console.log(formmatedData);
    AxiosAPI({
      method: 'put',
      url: `${postAPI_Update_Property}/${id}`,
      data: formmatedData,
    }).then(
      () => setVisible(false),
      setTimeout(() => {
        window.location.reload();
      }, 1000)
    );
  };

  return (
    <div>
      <Button
        color="primary"
        size="sm"
        onClick={() => setIsUpdating(!isUpdating)}
      >
        Edit
      </Button>
      {isUpdating && (
        <PropertyForm
          formLabel="Update Property"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          id={id}
          submit={handleSubmit}
          groupId={groupId}
        />
      )}
    </div>
  );
}
